import { ExtensionProperty, IProperty, Nullable, PropertyType, vec3 } from "@gltf-transform/core3";
import { CYNCLY_LIGHTS_METADATA } from "../constants";

interface ILightMetadata extends IProperty {

    /**
     * Declares the type of the light.
     */
    type: LightType;

    /**
     * Measure of how much light is emitted by this source in Lumens.
     */
    intensity: number | null;

    /**
     * RGB value for light's color in linear space.
     * @defaultValue [1, 1, 1]
     */
    color: vec3 | null;

    /**
     * The beam angle in degrees. Also known as apex angle. Specific to light type `spot`
     */
    beamAngle: number | null;
}

/**
 * Defines Light metadata attached to a {@link Node}. See {@link CYNCLYLightsMetadata}.
 */
export class LightMetadata extends ExtensionProperty<ILightMetadata> {
	public static EXTENSION_NAME = CYNCLY_LIGHTS_METADATA;
	public extensionName = CYNCLY_LIGHTS_METADATA;
	public propertyType = "LightMetadata";
	public parentTypes = [PropertyType.NODE];

	protected init(): void {
		this.extensionName = CYNCLY_LIGHTS_METADATA;
		this.propertyType = "LightMetadata";
		this.parentTypes = [PropertyType.NODE];
	}

	protected getDefaults(): Nullable<ILightMetadata> {
		return Object.assign(super.getDefaults() as IProperty, {
			type: null,
			intensity: null,
			color: null,
			beamAngle: null,
		});
	}

	public getType(): LightType {
		return (this as any).get("type");
	}

	public setType(type: LightType): this {
		return (this as any).set("type", type);
	}

	public getIntensity(): number | null {
		return (this as any).get("intensity");
	}

	public setIntensity(intensity: number | null): this {
		return (this as any).set("intensity", intensity);
	}

	public getColor(): vec3 | null {
		return (this as any).get("color");
	}

	public setColor(color: vec3 | null): this {
		return (this as any).set("color", color);
	}

	public getBeamAngle(): number | null {
		return (this as any).get("beamAngle");
	}

	public setBeamAngle(beamAngle: number | null): this {
		return (this as any).set("beamAngle", beamAngle);
	}
}
